import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=e4c2c822&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=ts&"
export * from "./ColumnList.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnList.vue?vue&type=style&index=0&id=e4c2c822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2c822",
  null
  
)

export default component.exports